module.exports = __webpack_public_path__ + "static/media/admin.6fc129aa.svg";